import { Link } from "react-router-dom";
import { IconAvatar } from "@/components/app/IconAvatar";
import { partnerFirstName, useWorkspaces } from "@/lib/workspaces";

// With two or more partnerships, the workspace page names every workspace you have and lets
// you move between them. The tab you were on (check-in, calendar, focus) carries across.
export default function WorkspaceSwitcher({ currentId, tab }) {
  const workspaces = useWorkspaces();
  if (workspaces.length < 2) return null;
  const query = tab && tab !== "checkin" ? `?tab=${tab}` : "";
  return (
    <nav aria-label="Switch workspace" className="mb-6" data-testid="ws-switcher">
      <div className="mb-2 text-xs text-[#A1A1AA]">Your workspaces</div>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {workspaces.map((workspace) => {
          const current = workspace.id === currentId;
          return (
            <Link
              key={workspace.id}
              to={`/workspace/${workspace.id}${query}`}
              aria-current={current ? "page" : undefined}
              data-testid={`ws-switch-${workspace.id}`}
              className={`flex shrink-0 items-center gap-3 rounded-md border py-2 pl-2 pr-4 transition-colors ${
                current
                  ? "border-[#F59E0B] bg-[#F59E0B]/10 text-[#F5F5F0]"
                  : "border-white/10 bg-white/[0.02] text-[#A1A1AA] hover:border-white/25 hover:text-[#F5F5F0]"
              }`}
            >
              <IconAvatar iconKey={workspace.partner?.profileIcon} size="sm" tone={current ? "amber" : "ghost"} />
              <span className="min-w-0">
                <span className="block truncate text-sm">You & {partnerFirstName(workspace)}</span>
                <span className="block text-[11px] text-[#8a8a92]">{current ? "Open now" : workspace.pending ? "Awaiting confirmation" : "Switch to this workspace"}</span>
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
